// Generate the project resources
export const generateProjectResources = (projects: any) => {

    // Initialize variable to store the resources
    const resources = [];

    // Loop through the projects from the response
    for (const project of projects) {

        // Loop through the jobs of the project
        for (const job of project.jobs) {

            // Add the project job as resource
            resources.push({
                id: job.id.toString(),
                created: job.created,
                number: job.number,
                job_type: job.type_name,
                description: job.description ?? "",
                required_employees: job.required_employees ?? {},
                project: {
                    id: project.id,
                    ordering: project.ordering,
                    name: project.name,
                    number: project.number,
                    client_name: project.client_name,
                    work_location_city: project.work_location_city,
                    default_start_time: project.default_start_time,
                    default_end_time: project.default_end_time,
                    default_break_duration: project.default_break_duration,
                }
            })
        }
    }

    return resources;
}

// Generate the individual job resources
export const generateIndividualJobResources = (individual_jobs: any) => {

    // Initialize variable to store the resources
    const resources = [];

    // Loop through the jobs from the response
    for (const job of individual_jobs) {

        // Add the job as resource
        resources.push({
            id: job.id.toString(),
            created: job.created,
            number: job.number,
            job_type: job.type_name,
            description: job.description ?? "",
            client_name: job.client_name,
            work_location_city: job.work_location_city,
            target_date: job.target_date,
            estimated_duration: job.estimated_duration
        })
    }

    return resources;
}